// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__t1fpF","buttonPag":"styles_buttonPag__APnY5","numbersOfPage":"styles_numbersOfPage__OEdl3"};